<template>
  <div class="home">
    <section class="main-section home">
      <div>
        <h1 class="main-title">
          守護神車禍處理
        </h1>
        <h2
          style="color:white;font-weight: normal;filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));"
        >
          AI車禍處理，協助車禍當事人，<br>找到方向，解決危機。
        </h2>
        <br>
        <el-button
          v-show="!$store.state.loginState"
          type="primary"
          class="title-btn"
          @click="$router.push('/register')"
        >
          加入會員開始諮詢
        </el-button>
        <el-button
          v-show="$store.state.loginState"
          type="primary"
          class="title-btn"
          @click="$store.commit('setConsultVisible', true)"
        >
          開始諮詢
        </el-button>
        <br>
        <el-button
          type="info"
          class="title-btn"
          @click="$router.push('/contact')"
        >
          聯絡我們
        </el-button>
      </div>
    </section>
    <section class="main-section section1">
      <div>
        <div style="text-align:center">
          <h1 class="main-title">
            車禍事故處理流程
          </h1>
          <h3>
            一圖看懂車禍處理流程！
          </h3>
        </div>
        <div style="text-align:left">
          <el-timeline>
            <el-timeline-item
              timestamp="發生當下"
              placement="top"
              color="white"
              size="large"
            >
              <el-card :body-style="cardstyle">
                <ul>
                  <li>聯絡保險公司、警察機關</li>
                  <li>自行拍攝事故現場、車損情形照片</li>
                  <li>
                    取得道路交通事故<el-link
                      type="primary"
                      href="../accident/b1"
                      :underline="false"
                    >
                      當事人登記聯單
                    </el-link>
                  </li>
                </ul>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              timestamp="7日後"
              placement="top"
              color="white"
              size="large"
            >
              <el-card :body-style="cardstyle">
                申請：<el-link
                  :underline="false"
                  type="primary"
                  href="../procedure/c4"
                >
                  道路交通事故現場圖
                </el-link>、<el-link
                  :underline="false"
                  type="primary"
                  href="../procedure/c5"
                >
                  照片
                </el-link>、<el-link
                  :underline="false"
                  type="primary"
                  href="../procedure/c7"
                >
                  事故當事人資料
                </el-link>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              timestamp="30日後"
              placement="top"
              color="white"
              size="large"
            >
              <el-card :body-style="cardstyle">
                申請：<el-link
                  :underline="false"
                  type="primary"
                  href="../procedure/c6"
                >
                  道路交通事故初步分析研判表*
                </el-link>、<el-link
                  :underline="false"
                  type="primary"
                  href="../procedure/d1"
                >
                  車禍鑑定**
                </el-link>
                ，申請完畢後，<el-link
                  :underline="false"
                  type="primary"
                  href="../procedure/e1"
                >
                  申請調解
                </el-link>
                <div style="margin-top:15px">
                  <u
                    style="color:#f56c6c"
                  >*若對於<u style="color:#52a7ff">初步分析研判表</u>之肇事原因如有疑義時，仍應以「公路法」第67條所定車輛行車事故鑑定委員會鑑定之結果或法院之判決為最終之確定。</u>
                </div>
                <div style="margin-top:15px">
                  <u
                    style="color:#f56c6c"
                  >**若對於<u style="color:#52a7ff">車禍鑑定</u>當事人仍有異議時，得於收受鑑定書之翌日起30日內申請覆議。</u>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              timestamp="6個月內"
              placement="top"
              icon="el-icon-stopwatch"
              size="large"
              color="#f56c6c"
            >
              車禍刑事訴訟追訴期限
            </el-timeline-item>
            <el-timeline-item
              timestamp="2年內"
              placement="top"
              icon="el-icon-stopwatch"
              size="large"
              color="#f56c6c"
            >
              車禍民事訴訟追訴期限
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </section>
    <section class="main-section section2">
      <h1 class="main-title">
        平台簡介
      </h1>
      <div>
        <div style="margin-bottom: 10px">
          台灣交通事故頻繁發生，如何正確處理車禍事故，已經成為每位駕駛人及用路人必備的知識。
        </div>
        <div style="margin-bottom: 10px">
          守護神AI車禍處理團隊，以多年的車禍處理經驗，整合律師、醫師、車禍鑑定專家、安全駕駛管理科技等相關領域專家的經驗及知識，提供相關車禍處理知識庫，全方位協助當事人因應車禍所生各項困惑。
        </div>
        <div style="margin-bottom: 10px">
          平台內提供詳細車禍處理流程與範例圖示，提供使用者在發生車禍後，如何處理的建議與協助，讓使用者能即時即地查詢解惑，再也不用搜尋無序的內容，即能一步步循序解決車禍問題與紛爭。
        </div>
        <div>
          使用者若因案件類型較為複雜或無法利用平台資訊解決雙方紛爭時，可進一步與本公司聯繫並說明相關情況，我們將會為您提供專業且客製化的服務，為您解決危機！
        </div>
      </div>
    </section>
    <section class="main-section section3">
      <div>
        <div style="text-align:center">
          <h1 class="main-title">
            專業整合服務團隊
          </h1>
          <h3>
            專業、熱忱、為您解決危機！
          </h3>
          <div>
            <el-carousel
              :type="carouselType.type"
              :height="carouselType.height"
              :interval="4000"
              :autoplay="false"
              arrow="always"
            >
              <el-carousel-item style="border-radius:5px;overflow-y: hidden;">
                <el-row style="background-color:#d3dce6;">
                  <el-col
                    :sm="11"
                    :sx="24"
                  >
                    <img
                      src="@/assets/江大寧律師.jpg"
                      class="image"
                    >
                  </el-col>
                  <el-col
                    :sm="13"
                    :sx="24"
                  >
                    <div class="lawyer-info">
                      <h2>江大寧律師</h2>
                      台灣大學法律系
                      <ul style="text-align: left;">
                        <li>執業律師</li>
                        <li>法官助理</li>
                        <li>國家高等考試民間公證人考試及格。</li>
                        <li>專利代理人。</li>
                        <li>高雄市國稅局諮詢律師。</li>
                        <li>高雄市澄清湖扶輪社2013-2014年度社長。</li>
                        <li>團法人犯罪被害人保護協會台灣高雄分會諮詢律師。</li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
              <el-carousel-item style="border-radius:5px;overflow-y: hidden;">
                <el-row style="background-color:#d3dce6;">
                  <el-col
                    :sm="11"
                    :sx="24"
                  >
                    <img
                      src="@/assets/汪紹銘律師.jpg"
                      class="image"
                    >
                  </el-col>
                  <el-col
                    :sm="13"
                    :sx="24"
                  >
                    <div class="lawyer-info">
                      <h2>汪紹銘律師</h2>
                      <div>東吳大學法律研究所</div>
                      <div>東吳大學法律系比較法學組</div>

                      <ul style="text-align: left;">
                        <li>執業律師</li>
                        <li>著作：</li>
                        <ol style="padding-left:20px;">
                          <li>醫事法入門</li>
                          <li>刑事上訴理由書之建構</li>
                          <li>意外事故理賠秘笈</li>
                        </ol>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
              <el-carousel-item style="border-radius:5px;overflow-y: hidden;">
                <el-row style="background-color:#d3dce6;">
                  <el-col
                    :sm="11"
                    :sx="24"
                  >
                    <img
                      src="@/assets/廖虹羚律師.jpg"
                      class="image"
                    >
                  </el-col>
                  <el-col
                    :sm="13"
                    :sx="24"
                  >
                    <div class="lawyer-info">
                      <h2>廖虹羚律師</h2>
                      國立中興大學法律系

                      <ul style="text-align: left;">
                        <li>執業律師(民國82年~迄今)</li>
                        <li>高雄市政府法律顧問(民國88~89年)</li>
                        <li>高雄地方法院民事庭調解委員(民國100年以前)</li>
                        <li>台北地方法院民事庭調解委員(民國100~迄今)</li>
                        <li>
                          財團法人法律扶助基金會家事扶助律師
                          審查委員(民國100~迄今)
                        </li>
                        <li>行政院環保署公害糾紛裁決會委員(民國106~迄今)</li>
                        <li>
                          行政院勞動部
                          性別平等訴訟法律扶助審查小組委員(民國108~迄今)
                        </li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
              <el-carousel-item style="border-radius:5px;overflow-y: hidden;">
                <el-row style="background-color:#d3dce6;">
                  <el-col
                    :sm="11"
                    :sx="24"
                  >
                    <img
                      src="@/assets/鄭皓文律師.jpg"
                      class="image"
                    >
                  </el-col>
                  <el-col
                    :sm="13"
                    :sx="24"
                  >
                    <div class="lawyer-info">
                      <h2>鄭皓文律師</h2>
                      <div>臺灣大學法律研究所財稅法組</div>
                      <div>輔仁大學法律系學士</div>

                      <ul style="text-align: left;">
                        <li>執業律師</li>
                        <li>恆鼎法律事務所主持律師</li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
              <el-carousel-item style="border-radius:5px;overflow-y: hidden;">
                <el-row style="background-color:#d3dce6;">
                  <el-col
                    :sm="11"
                    :sx="24"
                  >
                    <img
                      src="@/assets/簡登豪法務.jpg"
                      class="image"
                    >
                  </el-col>
                  <el-col
                    :sm="13"
                    :sx="24"
                  >
                    <div class="lawyer-info">
                      <h2>簡登豪法務</h2>
                      <div>高雄市立空中大學法政學系</div>

                      <ul style="text-align: left;">
                        <li>品永法律事務所法務</li>
                        <li>全泰然專業理賠服務團隊專案經理</li>
                        <li>全泰然危機管理顧問有限公司專案經理</li>
                        <li>信託業務人員測驗合格</li>
                        <li>人身保險業務員資格測驗合格</li>
                        <li>投資型保險商品資格測驗合格</li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { computed } from 'vue'
export default {
  name: 'Home',
  components: {},
  setup () {
    const cardstyle = {
      padding: '16px 20px'
    }
    const carouselType = computed(() => {
      if (window.innerWidth > 769) {
        return { type: 'card', height: '400px' }
      } else {
        return { type: '', height: '800px' }
      }
    })
    return { cardstyle, carouselType }
  }
}
</script>
<style lang="scss" scoped>
$phones-media: 600px;
.el-carousel__item {
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
}

.el-link.el-link--primary {
  vertical-align: baseline;
  color: var(--el-color-primary);
  font-size: 14px;
  transition: 150ms;
  &:hover {
    filter: brightness(150%);
    transition: 150ms;
  }
}
@media only screen and (max-width: $phones-media) {
  //手機版css
  .main-section {
    background-size: cover;
    background-position: center;
    min-height: 75vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    :first-child {
      text-align: left;
    }
    &.home {
      background-image: url('../assets/Home-road.jpg');
      text-align: center;
    }
    h2 {
      font-size: 6vmin;
    }
  }
  .main-title {
    font-size: 8vmin;
    color: white;
    filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.7));
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .section1 {
    background-image: url('../assets/Procedure.jpg');
    border-top: 4px dashed;
    border-color: white;
    .main-title {
      color: white;
      text-align: center;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.7));
    }
  }
  .section2 {
    background-image: url('../assets/Accident.jpg');
    border-top: 4px dashed;
    border-color: white;
    min-height: 40vh;
    .main-title {
      text-align: center;
      color: white;
      filter: none;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.7));
      width: 100%;
    }
    div {
      text-align: justify;
      color: white;
      width: 90vw;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
      margin-bottom: 50px;
    }
  }
  .el-carousel {
    width: 100vw;
    margin-bottom: 40px;
    img {
      width: 50%;
      display: block;
      filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7));
      border-radius: 5px;
      margin-top: 15px;
    }
    .el-row {
      height: 100%;
    }
    .el-col {
      min-height: 75%;
      display: flex;
      align-items: start;
      justify-content: center;
      h2 {
        font-size: 6vmin;
      }
      div {
        font-size: 4vmin;
      }
      &:first-child {
        min-height: 40%;
      }
    }
  }

  .section3 {
    background-image: url('../assets/Procedure.jpg');
    border-top: 4px dashed;
    border-color: white;
    .main-title {
      text-align: center;
      color: white;
      filter: none;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.7));
    }
  }
  .title-btn {
    font-size: 14px;
    font-family: 'Gen Jyuu Gothic';
    font-weight: normal;
    transition: 500ms;
    margin: 5px;
    &:hover {
      filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
      transition: 500ms;
    }
  }
  ::v-deep .el-timeline-item__timestamp {
    color: white;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
  }
  ::v-deep .el-timeline-item__content {
    color: white;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
  }
  .el-timeline {
    padding: 15px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    margin-bottom: 30px;
  }
  .lawyer-info {
    width: 80%;
  }
}
@media only screen and (min-width: $phones-media) {
  //電腦版css
  .main-section {
    background-size: cover;
    background-position: center;
    min-height: 75vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    br {
      display: none;
    }
    &.home {
      background-image: url('../assets/Home-road.jpg');
      text-align: center;
    }
  }
  .main-title {
    font-size: 5vmin;
    color: white;
    filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.7));
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .section1 {
    background-image: url('../assets/Procedure.jpg');
    border-top: 4px dashed;
    border-color: white;
    .main-title {
      color: white;
      filter: none;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.7));
    }
  }
  .section2 {
    background-image: url('../assets/Accident.jpg');
    border-top: 4px dashed;
    border-color: white;
    min-height: 40vh;
    .main-title {
      color: white;
      filter: none;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.7));
      margin-right: 50px;
    }
    div {
      text-align: justify;
      color: white;
      width: 50vw;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
    }
  }
  .el-carousel {
    width: 70vw;
    img {
      width: 100%;
      display: block;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.5));
      object-fit: cover;
    }
    .el-col {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 14px;
    }
  }
  .section3 {
    background-image: url('../assets/Procedure.jpg');
    border-top: 4px dashed;
    border-color: white;
    .main-title {
      color: white;
      filter: none;
      filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.7));
    }
    .el-row {
      height: 100%;
    }
  }
  .title-btn {
    font-size: 2vmin;
    font-family: 'Gen Jyuu Gothic';
    font-weight: normal;
    transition: 500ms;
    margin: 5px;
    &:hover {
      filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
      transition: 500ms;
    }
  }
  ::v-deep .el-timeline-item__timestamp {
    color: white;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
  }
  ::v-deep .el-timeline-item__content {
    color: white;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
  }
  .el-timeline {
    padding: 15px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    margin-bottom: 30px;
  }
}
</style>
